import * as Sentry from '@sentry/react';
import type { Client } from '@sentry/core';
import { User, Account } from '@cliengo/mfe-utils/types';

declare global {
  interface Window {
    cliengo_sentry_client: Client;
  }
}

export class SentryClient {
  private client: Client;

  init() {
    const client = Sentry.init({
      dsn: 'https://6c67e00997c2046c28ce9fd4c07f561e@o1133800.ingest.us.sentry.io/4508926315659264',
      sendDefaultPii: true,
      attachStacktrace: true,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.captureConsoleIntegration({
          levels: ['error', 'warn'],
        }),
      ],
      tracesSampleRate: 1.0,
      enabled: process.env.ENVIRONMENT === 'prod',
    });

    this.client = client;
    window.cliengo_sentry_client = this.client;
  }

  captureException(error: Error) {
    this.client.captureException(error);
  }

  captureMessage(message: string) {
    this.client.captureMessage(message);
  }

  setCurrentUser(user: User, account: Account) {
    const sentryUser: Sentry.User = {
      id: user.id,
      email: user.email,
      name: user.name,
      user_agent: window.navigator.userAgent,
      user_privileges: user.privileges,
      company_id: account.id,
      company_name: account.name,
      company_plan: account.planType,
      company_labs: account.labs,
    };

    console.info('User identified in Sentry');
    Sentry.setUser(sentryUser);
  }
}

export const sentryClient = new SentryClient();
